




import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import AppMessage from '../../core/models/appMessage';

@Component
export default class Logout extends Vue {
  @Mutation('auth/logout') private logout!: () => void;

  public mounted() {
    this.logout();
    AppMessage.show(this.$t('logout.success'));
    this.$router.push('/login');
  }
}
